import './reference.scss';

import {React, useContext} from 'react';

import { SettingsContext } from '../../context/context';
import Weapons from '../layouts/card/weapons/weapons';

const Reference = ({roster}) => {
  const {state} = useContext(SettingsContext);

  const abilities = {};
  const actions = {};
  const rules = {};

  const alphabetize = (a, b) => {
    console.log('A', a, 'B', b);
    const cleanedA = a.name.replace(/[^a-z0-9]/gi, '');
    const cleanedB = b.name.replace(/[^a-z0-9]/gi, '');
    if(cleanedA.toLowerCase() < cleanedB.toLowerCase()) return -1;
    if(cleanedA.toLowerCase() > cleanedB.toLowerCase()) return 1;
    return 0;
  }

  roster.units.map((unit) => {
    unit.abilities.map((ability) => abilities[ability.name] = ability);
    unit.uniqueActions.map((action) => actions[action.name] = action);
    Object.keys(unit.rules).map((ruleKey) => rules[ruleKey] = (unit.rules[ruleKey]));
  });

  const abilitiesList = Object.keys(abilities).map((abilityKey) => abilities[abilityKey]);
  const actionsList = Object.keys(actions).map((actionKey) => actions[actionKey]);
  const rulesList = Object.keys(rules).map((ruleKey) => rules[ruleKey])

  let weaponsList = [];
  const weaponsDictionary = {};

  if (state.weaponsRef) {
    roster.units.map((unit) => {
      return unit.weapons.map((weapon) => weaponsDictionary[weapon.name] = weapon)
    });
    let tempList = [];
    if (state.displayEquipment) {
      tempList = Object.keys(weaponsDictionary).map((weapon) => weaponsDictionary[weapon]);
    } else {
      tempList = Object.keys(weaponsDictionary).filter((weaponName) => !weaponsDictionary[weaponName].addon).map((weapon) => weaponsDictionary[weapon]);
    }

    weaponsList = tempList.sort(alphabetize);
  }

  const cleanName = (name) => {
    return name.replace(/[^a-z0-9 ]/gi, '');
  }

  return (<>
    { state.coreRules ? (<div className="reference weapons-ref sheet padding-5mm">
      <h1>Core Rules Reference</h1>
      { rulesList.length > 0 && (
      <div className="reference-section">
        <table>
          <tbody>
            { rulesList.sort(alphabetize).map((rule, index) => (
            <tr key={index}>
              <td className="name" dangerouslySetInnerHTML={{__html: rule.name }} />
              <td dangerouslySetInnerHTML={{__html: rule.description}} />
            </tr>
          )) }
          </tbody>
        </table>
      </div>
    )}
    </div>) : null}

    {state.factionRules ? (<div className="reference sheet padding-5mm">
      <h1>Faction Rules Reference</h1>
      { abilitiesList.length > 0 && (
        <div className="reference-section">
          <h2>Abilities</h2>
          <table>
            <tbody>
              { abilitiesList.sort(alphabetize).map((ability, index) => (
              <tr key={index}>
                <td className="name" dangerouslySetInnerHTML={{__html: ability.name }} />
                <td dangerouslySetInnerHTML={{__html: ability.description}} />
              </tr>
            )) }
            </tbody>
          </table>
        </div>
      )}

      { actionsList.length > 0 && (<div className="reference-section">
        <h2>Unique Actions</h2>
        <table>
          <tbody>
            { actionsList.sort(alphabetize).map((action, index) => (
              <tr key={index}>
                <td className="name" dangerouslySetInnerHTML={{__html: action.name}} />
                <td dangerouslySetInnerHTML={{__html: action.description}} />
              </tr>
            )) }
          </tbody>
        </table>
      </div>) }
    </div>) : null}

    { state.weaponsRef ? (<div className="reference sheet padding-5mm">
      <h1>Weapons { state.displayEquipment ? (`& Equipment `) : null }Reference</h1>
      <table className="weapons-ref">
        <thead>
          <tr>
            <th>&nbsp;</th>
            <th>
              <table className="weapon-stats">
                <thead><tr>
                  <th>A</th>
                  <th>WS/BS</th>
                  <th>D</th>
                  <th className="sr">SR</th>
                  <th>!</th>
                </tr></thead>
              </table>
            </th>
          </tr>
        </thead>
        <tbody>
          { weaponsList.map((weapon, index) => (
              <tr key={index}>
                <td className="name" dangerouslySetInnerHTML={{__html: cleanName(weapon.name)}} />
                <td>
                  { weapon.stats.A ? (
                    <table className="weapon-stats">
                      <tbody>
                        <tr>
                        <td>{weapon.stats.A}</td>
                        <td className="center">{weapon.stats['WS/BS']}</td>
                        <td className="center">{weapon.stats.D}</td>
                        <td className="sr">{weapon.stats.SR}</td>
                        <td>{weapon.stats['!'] === '' ? '-' : weapon.stats['!']}</td>
                        </tr>
                      </tbody>
                    </table>
                  ) : null }
                  { weapon.description ? (<p>{weapon.description}</p>) : null}
                </td>
              </tr>
          )) }
        </tbody>
      </table>
    </div>) : null }
  </>);

};

export default Reference;
